// extracted by mini-css-extract-plugin
export var truncate = "_s-0";